module.exports = __webpack_public_path__ + "img/logo2.b3d9c40d.jpg";